import './DirectoryInput.css';
import React, { useEffect, useCallback } from 'react';
import { 
    FaFolder, 
    FaFolderOpen,
} from "react-icons/fa";
import { withTranslate } from 'react-redux-multilingual';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import {
    IsValidDirectoryName,
} from '../../../libraries/Tool';

function DirectoryInput(props) {
    const { translate, padding, isOpen, value, onClickSave, onClickCancel } = props;

    const [directoryName, setDirectoryName] = React.useState("");

    const FolderIcon = () =>
        isOpen 
        ? (<FaFolderOpen color="e8a87c" className="icon" />)
        : (<FaFolder color="e8a87c" className="icon" />)
    ;

    useEffect(() => {
        setDirectoryName(value);
    }, [value])

    return (
        <Box className='directory-input-box' sx={{ padding }}>
            <FormControl fullWidth>
                <OutlinedInput 
                    type="text" 
                    size='small'
                    color='secondary'
                    className='directory-name'
                    placeholder={translate('directoryname')}
                    value={directoryName}
                    startAdornment={
                        <InputAdornment position="start" sx={{ mr: 0 }}>
                            <FolderIcon />
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position="end">
                            {(directoryName && IsValidDirectoryName(directoryName)) 
                            ? <CheckIcon color='success' /> 
                            : (directoryName && !IsValidDirectoryName(directoryName)) 
                            ? <PriorityHighIcon color="error" />
                            : ""}
                        </InputAdornment>
                    }
                    onChange={(e) => setDirectoryName(e.target.value)}
                />
            </FormControl>
            <Button size="small" variant="outlined" color='secondary' onClick={() => onClickCancel(directoryName)}>{translate('cancel')}</Button>
            <Button size="small" variant="contained" color='primary' onClick={() => onClickSave(directoryName)} disabled={!IsValidDirectoryName(directoryName)}>{translate('save')}</Button>
        </Box>
    );
}
export default withTranslate(DirectoryInput);